import React from "react";
import {observer} from "mobx-react";
import {useCatalogShowMore} from "../model/useCatalogShowMore";
import {Button} from "@/shared/ui/Button";
import styles from "./CatalogShowMore.module.scss";

export const CatalogShowMore = observer(() => {
    const {hasMore, loading, showMore} = useCatalogShowMore();

    if (!hasMore) return null;

    return (
        <div className={styles.showMoreContainer}>
            <Button
                variant={`secondary`}
                loading={loading}
                onClick={showMore}
                fullWidth
            >
                Показать еще
            </Button>
        </div>
    );
});
